/**
 * Vuex mutation 常數
 *
 * 還原自 chunk-common.js 模組 b6cf。原始 bundle 中這些常數被 webpack 匯出為
 * 單字母代號（c["h"]、c["a"] …），此處對照 mutation 實作內容還原回原名。
 * 20 個常數與原始 bundle 完全一致。
 */

export const LANGUAGE = 'LANGUAGE'
export const SCROLL = 'SCROLL'
export const PRODUCT = 'PRODUCT'
export const SEL_PRODUCT = 'SEL_PRODUCT'

export const CART_SET = 'CART_SET'
export const CART_ADD = 'CART_ADD'
export const CART_EDIT = 'CART_EDIT'
export const CART_DELETE = 'CART_DELETE'

export const NAME_SET = 'NAME_SET'
export const NUMBER_SET = 'NUMBER_SET'
export const REMARK_SET = 'REMARK_SET'
export const CLOSE = 'CLOSE'
export const CLIENT_ID = 'CLIENT_ID'
export const STORE_STATUS = 'STORE_STATUS'
export const ORDER_ID = 'ORDER_ID'
export const DISCOUNT_SET = 'DISCOUNT_SET'

export const ORDER_TYPE_SET = 'ORDER_TYPE_SET'
export const ORDER_TYPE_PICK_UP = 'ORDER_TYPE_PICK_UP'
export const ORDER_TYPE_DELIVERY = 'ORDER_TYPE_DELIVERY'

export const LOCATION_SET = 'LOCATION_SET'
export const OPEN_CART = 'OPEN_CART'
